<script setup lang="ts">
  import { computed } from 'vue';

  import { getErrorMessages } from '@bv/helpers/form/error-message';

  import type { ErrorObject } from '@vuelidate/core';

  const props = withDefaults(
    defineProps<{
      errors?: string | string[] | ErrorObject | ErrorObject[];
      maxErrors?: number;
    }>(),
    {
      errors: undefined,
      maxErrors: 1,
    },
  );

  const validMaxErrors = computed<number>(() => {
    return Number.isFinite(props.maxErrors) && props.maxErrors > 0 ? Math.floor(props.maxErrors) : 1;
  });

  const errors = computed<string[]>(() => {
    return getErrorMessages(props.errors).filter(Boolean).slice(0, validMaxErrors.value);
  });
</script>

<template>
  <transition name="fade-slide">
    <div
      v-if="errors.length"
      class="bv-error-msg text-xs"
    >
      <p
        v-for="(error, index) in errors"
        :key="`${error}-${index}`"
      >
        {{ error }}
      </p>
    </div>
  </transition>
</template>
